import { AxiosPromise } from "axios";
import type { Document } from "types/document";
import { request } from "utils/request";

export interface DocumentListParams {
  projectId?: number;
  page?: number;
  limit?: number;
  search?: string;
  staffId?: number;
}

export interface DocumentListResponse {
  documents: Document[];
}

export const documentApi = {
  findAll: (params?: DocumentListParams): AxiosPromise<DocumentListResponse> =>
    request({
      url: "/v1/admin/documents",
      params,
    }),
};
